import * as React from 'react';
import ReactQuill, { Quill } from 'react-quill';

import { titleCaseSnakeCasing } from 'utils/text';
import { useStyles } from 'app/pages/GenerateEmailFromTemplatesPage/style';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import { QuillEditor } from 'app/components/QuillEditorComponent/Loadable';

let Size = Quill.import('attributors/style/size');
Size.whitelist = [
  '8px',
  '9px',
  '10px',
  '11px',
  '12px',
  '13px',
  '14px',
  '18px',
  '24px',
  '32px',
  '36px',
  '48px',
];
Quill.register(Size, true);

let Block = Quill.import('blots/block');
Block.tagName = 'div';
Quill.register(Block);

let Font = Quill.import('attributors/style/font');
Font.whitelist = ['arial', 'roboto'];
Quill.register(Font, true);

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [
      {
        size: Size.whitelist,
      },
    ], // custom dropdown
    [{ font: Font.whitelist }],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ align: [] }],
    ['clean'], // remove formatting button
    // [{ header: [1, 2, 3, 4, 5, 6, false] }],
    // ['link', 'image', 'video', 'formula'],

    // [{ header: 1 }, { header: 2 }], // custom button values
    // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    // [{ direction: 'rtl' }], // text direction
  ],
};

export default function Step3({
  templateContentVariables,
  setTemplateContentVariables,
}) {
  const classes = useStyles();

  return (
    <Stack spacing={3}>
      <Typography
        variant="h5"
        gutterBottom
        component="div"
        sx={{ marginBottom: '10px', width: '100%' }}
      >
        Select Text Content
      </Typography>

      {Object.keys(templateContentVariables).length > 0 &&
        Object.keys(templateContentVariables).map((item, index) => (
          <>
            <Typography variant="subtitle1" gutterBottom component="div">
              {titleCaseSnakeCasing(item || '')}
            </Typography>

            <ReactQuill
              theme="snow"
              modules={modules}
              // formats={formats}
              value={templateContentVariables[item]}
              onChange={text =>
                setTemplateContentVariables(old => ({
                  ...old,
                  [item]: text,
                }))
              }
              className={classes.toolbar}
              style={{
                marginTop: '0px',
                marginBottom: '40px',
              }}
            />
          </>
        ))}
    </Stack>
  );
}
